import { getAPI } from "./base";
import axios from "axios";

import { logAiToolkitError } from "./errorsHelper";

// Iterator
export async function uploadExcelAndGetBlob(
  formFile,
  multiPrompt = false,
  isTest = false,
) {
  try {
    const formData = new FormData();
    formData.append("file", formFile);

    const params = new URLSearchParams({
      multi_prompt: multiPrompt.toString(),
      test: isTest.toString(),
    });

    const api = getAPI();
    const response = await api.post(
      `/new_iteration?${params.toString()}`,
      formData,
      {
        responseType: "blob",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message ||
          error.response.statusText ||
          "Unknown server error";
        console.error(`Iterator failed (${status}): ${message}`);
      } else if (error.request) {
        console.error("Iterator failed: No response from server");
      } else {
        console.error("Iterator request setup failed:", error.message);
      }
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
}

// Translator
export async function processTranslator(formfile) {
  try {
    const formData = new FormData();
    formData.append("file", formfile);
    const api = getAPI();
    const response = await api.post("/translator", formData, {
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message ||
          error.response.statusText ||
          "Unknown server error";
        console.error(`Translation failed (${status}): ${message}`);
      } else if (error.request) {
        console.error("Translation failed: No response from server");
      } else {
        console.error("Translation request setup failed:", error.message);
      }
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
}

// Redaction
// Process Excel file for redaction
export async function processRedactionExcel(formfile, options = {}) {
  try {
    // Fallback
    const {
      sheetName = "Sheet1",
      textCol = "Redaction",
      model = "gpt-4.1-mini",
      batchSize = 250,
      maxConcurrent = 25,
      secondPass = true,
    } = options;

    const formData = new FormData();
    formData.append("file", formfile);

    const api = getAPI();

    const params = new URLSearchParams({
      sheet_name: sheetName,
      text_col: textCol,
      model: model,
      batch_size: batchSize.toString(),
      max_concurrent: maxConcurrent.toString(),
      second_pass: secondPass.toString(),
    });

    const response = await api.post(`/excel?${params.toString()}`, formData, {
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 600000, // 10 min for large files
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// Process CSV file for redaction
export async function processRedactionCSV(formfile, options = {}) {
  try {
    // Fallback
    const {
      sheetName = "Sheet1",
      textCol = "Redaction",
      model = "gpt-4.1-mini",
      batchSize = 250,
      maxConcurrent = 25,
      secondPass = true,
    } = options;

    const formData = new FormData();
    formData.append("file", formfile);

    const api = getAPI();

    const params = new URLSearchParams({
      sheet_name: sheetName,
      text_col: textCol,
      model: model,
      batch_size: batchSize.toString(),
      max_concurrent: maxConcurrent.toString(),
      second_pass: secondPass.toString(),
    });

    const response = await api.post(`/csv?${params.toString()}`, formData, {
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 600000, // 10 min timeout for large files
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// Function for backward compatibility
export async function processRedaction(formfile, options = {}) {
  const fileName = formfile.name.toLowerCase();

  if (fileName.endsWith(".csv")) {
    return await processRedactionCSV(formfile, options);
  } else if (fileName.endsWith(".xls") || fileName.endsWith(".xlsx")) {
    return processRedactionExcel(formfile, options);
  } else {
    throw new Error(
      "Unsupported file type for redaction. Please upload an Excel or CSV file.",
    );
  }
}

// Supplier Demand Constants

async function postFileForBlob(endpoint, formFile) {
  const formData = new FormData();
  formData.append("file", formFile);
  const api = getAPI();
  return api.post(endpoint, formData, {
    responseType: "blob",
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// Supply Constants
export async function processSupplyConstants(formFile) {
  try {
    return await postFileForBlob("/supply_constants", formFile);
  } catch (error) {
    logAiToolkitError(error, "Supply Constants");
    throw error;
  }
}

// Demand Constants
export async function processDemandConstants(formFile) {
  try {
    return await postFileForBlob("/demand_constants", formFile);
  } catch (error) {
    logAiToolkitError(error, "Demand Constants");
    throw error;
  }
}
